export default __webpack_public_path__ + "static/media/back-to-studio.a1c8fbff.svg";